import * as React from 'react';
import { Row, Col } from 'reactstrap';
import NavigationSidebarLinks from 'src/modules/Navigation/NavBar/components/NavigationSidebarLinks';
import { ComponentType, RoutesModules } from 'src/modules/Routing/types';
import Sidebar from 'src/modules/Routing/Sidebar/Siderbar';

const SidebarContainer = (moduleSection: RoutesModules | ComponentType) => (Component) => (props) => {
    const isComponent = typeof moduleSection === 'function';
    const SidebarComponent = moduleSection as any as ComponentType;
    return (
        <Row className="container-sidebar">
            <Col className="col-xs-3 col-md-3 col-lg-3 col-xl-2 col-sm-12 col-xs-12 d-none d-xs-none d-md-block no-padding-right">
                {
                    isComponent ?
                        <SidebarComponent {...props} /> :
                        <Sidebar className="sidebar">
                            <NavigationSidebarLinks sidebarModule={moduleSection as RoutesModules} />
                        </Sidebar>
                }
            </Col>
            <Col className="col-md-9 col-lg-9 col-xl-10 col-sm-12 no-padding-left">
                <Component {...props} />
            </Col>
        </Row>
    );
};

export default SidebarContainer;